import ClickableDiv from '../../ClickableDiv/ClickableDiv';
import useBrowserWidth from '../../hooks/useBrowserWidth';
import { SECTORS_PER_ROW, SECTORS_PER_ROW_MOBILE } from '../PopularGroups.constants';
import { PopularGroupItem, PopularGroupItemsProps } from '../PopularGroups.types';

import styles from './PopularGroupItems.module.scss';

const COMPACT_ROW_MAX_WIDTH = 1280;
const SHORT_LOGO_MIN_WIDTH = 1280;
const SHORT_LOGO_MAX_WIDTH = 1650;
const LAST_ROW_ETF_CAP = 4;
const LOADER_ROW_WIDTHS = [
  [255, 218, 310],
  [221, 188, 266],
  [264, 241, 218],
  [213, 187],
];

const PopularGroupItems = ({
  groups,
  isLoading,
  showEtf,
  onGroupClick,
}: PopularGroupItemsProps) => {
  const { browserWidthSize } = useBrowserWidth();

  const isShortLogo = () => browserWidthSize > SHORT_LOGO_MIN_WIDTH && browserWidthSize <= SHORT_LOGO_MAX_WIDTH;

  const getSectorsPerRowCount = () => (
    browserWidthSize < COMPACT_ROW_MAX_WIDTH ? SECTORS_PER_ROW_MOBILE : SECTORS_PER_ROW
  );

  if (isLoading) {
    return (
      <div>
        {LOADER_ROW_WIDTHS.map(row => (
          <div className={styles.loaderRow} key={row.join('-')}>
            {row.map(width => <div className={styles.row} style={{ width }} key={width} />)}
          </div>
        ))}
      </div>
    );
  }

  const renderGroup = (groupsData: PopularGroupItem[], key: string) => (
    <div key={key}>
      <div className={styles.wrapperRowGroups}>
        {groupsData.map(item => (
          <ClickableDiv
            key={item.id ?? item.sector}
            className={styles.group}
            onClick={() => onGroupClick(item)}
          >
            <div>
              <img
                className={isShortLogo() ? styles.shortIcon : styles.icon}
                src={isShortLogo() ? item.shortLogo : item.logo}
                alt=""
              />
            </div>
            <div className={styles.itemName}>
              {item.name}
            </div>
            <span className={styles.itemCount}>{`(${item.count})`}</span>
          </ClickableDiv>
        ))}
      </div>
    </div>
  );

  const perRow = getSectorsPerRowCount();
  const rows: PopularGroupItem[][] = [];
  for (let index = 0; index < groups.length; index += perRow) {
    rows.push(groups.slice(index, index + perRow));
  }

  return (
    <div className={styles.row}>
      {rows.map((row, index) => {
        const isLastRow = index === rows.length - 1;
        const rowItems = showEtf && isLastRow ? row.slice(0, LAST_ROW_ETF_CAP) : row;

        return renderGroup(rowItems, rowItems.map(item => item.sector).join('-'));
      })}
    </div>
  );
};

export default PopularGroupItems;
